import axiosInstance from './interceptor'

//add container to bottle order
export const addContainerToBottleOrder = async (params: any) => {

    return await axiosInstance.post(`BottleOrder/AddContainerToBottleOrder`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

//add package to bottle order
export const addPackageToBottleOrder = async (params: any) => {

    return await axiosInstance.post(`BottleOrder/AddPackagetoBottleOrder`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

//delete container from bottle order
export const deleteContainerItem = async (orderId: any, groupId: any, containerId: any) => {

    return await axiosInstance.delete(`BottleOrder/DeleteContainerFromOrder/${orderId}/${groupId}/${containerId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

//delete package from bottle order
export const deletePackageItem = async (orderId: any, packageId: any) => {

    return await axiosInstance.delete(`BottleOrder/DeletePackageFromOrder/${orderId}/${packageId}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    }) 
}